import "./error.css";

const ShowError = ({ error }) => {
    return <div className="error-page"></div>;
};

export default ShowError;
